import {CartGateway} from '../classes';
import cart from '@ppcp/cart';
import Actions from '@ppcp/actions';

new CartGateway(cart, {id: 'ppcp', actions: new Actions(), context: 'cart'});
